import React from "react";
import { NavLink, Outlet } from "react-router-dom";

const MetaDataManagement = () => {
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="TitleBox">
          <h2>Meta Data Management</h2>
        </div>

        <div className="CommonTabs">
          <ul className="nav nav-tabs">
            <li className="nav-item">
              <NavLink 
              to="CategoryMetaData"
               className="nav-link"
               data-toggle="tab"
              >
                Category
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="SubCategoryMetaData"
                className="nav-link"
        
              >
                SubCategory
              </NavLink>
            </li>
          </ul>
        </div>

        {/* 👇 Child pages yahan load hongi */}
        <Outlet />
      </div>
    </div>
  );
};

export default MetaDataManagement;
